// The page navigation of the browser, in one module: a flow test stubs it the
// way it stubs the network, since jsdom cannot navigate.
export function replaceLocation(url: string): void {
  window.location.replace(url);
}

export function reloadLocation(): void {
  window.location.reload();
}
